export const FETCH_VIEW_COURSE_DETAILS_REQUEST = "FETCH_VIEW_COURSE_DETAILS_REQUEST";
export const FETCH_VIEW_COURSE_DETAILS_SUCCESS = "FETCH_VIEW_COURSE_DETAILS_SUCCESS";
export const FETCH_VIEW_COURSE_DETAILS_FAILURE = "FETCH_VIEW_COURSE_DETAILS_FAILURE";

export const fetchViewCourseDetailsRequest = (courseDefintionID: string) => ({
  type: FETCH_VIEW_COURSE_DETAILS_REQUEST,
  payload: { courseDefintionID },
});
export const fetchViewCourseDetailsSuccess = (data: any) => ({
  type: FETCH_VIEW_COURSE_DETAILS_SUCCESS,
  payload: data,
});
export const fetchViewCourseDetailsFailure = (error: any) => ({
  type: FETCH_VIEW_COURSE_DETAILS_FAILURE,
  payload: error,
});
